import { useEffect, useState } from 'react';

// Tiny shared flag: TaxSetupGate sets it while its blocking dialog is on screen so
// page-level prerequisite dialogs ("Bank account required") never stack on top of it.
let open = false;
const listeners = new Set();

export const setTaxGateOpen = (value) => {
  if (open === value) return;
  open = value;
  listeners.forEach((fn) => fn(open));
};

export const useTaxGateOpen = () => {
  const [state, setState] = useState(open);
  useEffect(() => {
    listeners.add(setState);
    setState(open);
    return () => listeners.delete(setState);
  }, []);
  return state;
};
